module.exports = __webpack_public_path__ + "img/mines-card.4b961f8b.svg";